import { Component, output } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ButtonComponent } from 'src/components/button/button.component';

@Component({
  selector: 'step-completion',
  templateUrl: './step-completion.component.html',
  standalone: true,
  imports: [RouterModule, ButtonComponent],
})
export class _StepCompletionComponent {
  completed = output<void>();

  constructor() {}
}
